import { Capacitor } from '@capacitor/core';

const CONSENT_KEY = 'okio_bg_location_consent_v1';

// Prevents showing the disclosure multiple times within a single app launch
// if the user taps "Not Now". Resets on next cold start.
let promptedThisSession = false;

const isNative = () => {
  try { return Capacitor?.isNativePlatform?.() === true; } catch { return false; }
};

const LocationConsentService = {
  getConsent() {
    try {
      const raw = localStorage.getItem(CONSENT_KEY);
      if (!raw) return null;
      return JSON.parse(raw);
    } catch {
      return null;
    }
  },

  hasAccepted() {
    const consent = this.getConsent();
    return consent?.accepted === true;
  },

  hasResponded() {
    return this.getConsent() !== null;
  },

  accept() {
    promptedThisSession = true;
    try {
      localStorage.setItem(CONSENT_KEY, JSON.stringify({
        accepted: true,
        timestamp: Date.now(),
      }));
    } catch {}
  },

  decline() {
    promptedThisSession = true;
    try {
      localStorage.setItem(CONSENT_KEY, JSON.stringify({
        accepted: false,
        timestamp: Date.now(),
      }));
    } catch {}
  },

  wasPromptedThisSession() {
    return promptedThisSession;
  },

  reset() {
    promptedThisSession = false;
    try { localStorage.removeItem(CONSENT_KEY); } catch {}
  },

  needsDisclosure() {
    return isNative() && !this.hasAccepted();
  },

  // Returns true if location APIs are safe to call right now.
  // On web: always true (browser handles its own permission prompt).
  // On native: only after the prominent disclosure has been accepted.
  canAccessLocation() {
    if (!isNative()) return true;
    return this.hasAccepted();
  },
};

export default LocationConsentService;
